import { CREDIT_NOTE_STATUS_ENUMS } from "../types/index.js";
export var CREDIT_NOTE_ACTION;
(function (CREDIT_NOTE_ACTION) {
    CREDIT_NOTE_ACTION["SAVE"] = "SAVE";
    CREDIT_NOTE_ACTION["APPROVE_AND_APPLY"] = "APPROVE_AND_APPLY";
})(CREDIT_NOTE_ACTION || (CREDIT_NOTE_ACTION = {}));
export const CREDIT_NOTE_STATUSES = {
    DRAFT: {
        value: CREDIT_NOTE_STATUS_ENUMS.DRAFT,
        label: "Draft", // Created but not yet finalized or submitted. Can be edited.
    },
    // OPEN: {
    //   value: CREDIT_NOTE_STATUS_ENUMS.OPEN,
    //   label: "Open", // Finalized but not yet issued to the customer. Ready for approval or issuance.
    // },
    // ISSUED: {
    //   value: CREDIT_NOTE_STATUS_ENUMS.ISSUED,
    //   label: "Issued", // Officially sent to the customer. Can now be applied to invoices.
    // },
    // PARTIALLY_APPLIED: {
    //   value: CREDIT_NOTE_STATUS_ENUMS.PARTIALLY_APPLIED,
    //   label: "Partially Applied", // Credit note has been applied to one or more invoices, but some balance remains.
    // },
    CLOSED: {
        value: CREDIT_NOTE_STATUS_ENUMS.CLOSED,
        label: "Closed", // Fully applied to invoices or fully used. No further action required.
    },
    // VOID: {
    //   value: CREDIT_NOTE_STATUS_ENUMS.VOID,
    //   label: "Void", // Canceled before use. No impact on invoices or customer account.
    // },
    // EXPIRED: {
    //   value: CREDIT_NOTE_STATUS_ENUMS.EXPIRED,
    //   label: "Expired", // Credit note has expired and can no longer be applied to invoices.
    // },
    ARCHIVED: {
        value: CREDIT_NOTE_STATUS_ENUMS.ARCHIVED,
        label: "Archived", // Credit note has been archived and can no longer be used.
    }
};
//# sourceMappingURL=creditNote.js.map